import React, { Component, useState } from 'react';
import Input from '../Common/InputComponent';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FilterPanel } from './FilterPanel';
import { updateSortingPreferences } from '../../store/actions/postAction';

export class Filter extends Component {
    constructor() {
        super();
        this.state = {
            show: false
        }
    }

    // filterToggler = e => {
    //     this.setState({
    //         show: !this.state.show
    //     })
    // }
    filterToggler = () => {
        this.setState((prevState) => ({
            show: !prevState.show
        }));
    };

    handleApplyFilters = (sortBy, sortOrder) => {

        console.log("handleApplyFilters called!"); // Confirm function call
        console.log("Received sorting options:", sortBy, sortOrder);


        if (!sortBy || !sortOrder) return; // Null check: Do nothing if no values are selected
        // this.props.onSortChange(sortBy, sortOrder); // Pass sorting options to parent component
        // Dispatch sorting action instead of calling props function
        this.props.updateSortingPreferences(sortBy, sortOrder);
    };

    render() {
        return (
            <>
                <div className='row'>
                    <div className='col-sm-12'>
                        <div className='filter_main_container'>
                            <div onClick={this.filterToggler}><i className="fa fa-filter" aria-hidden="true"></i> &nbsp;Filters</div>
                        </div>
                    </div>
                </div>
                {/* { this.state.show ? <FilterPanel onClose={ this.filterToggler } /> : null } */}
                {this.state.show && (
                    <FilterPanel
                        onClose={this.filterToggler}
                        onApplyFilters={this.handleApplyFilters} // Pass function to FilterPanel
                    />
                )}
            </>
        )
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors.errors
})

export default connect(mapStateToProps, {updateSortingPreferences})(withRouter(Filter));
